export const KEYWORDS_BREAKDOWN_SCROLL_ID = "keywords-breakdown-scroll-target";

export const scrollToKeywordsBreakdown = (): void => {
    document.getElementById(KEYWORDS_BREAKDOWN_SCROLL_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
